import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { WIND_HEIGHTS } from "../../utils/windChartConstants";

interface Props {
  windHeight: string;
  setWindHeight: (height: string) => void;
}

const HeightDropdown = ({ windHeight, setWindHeight }: Props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  return (
    <div className="pb-8">
      <div className="relative w-fit ml-auto">
        <button
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-white text-[12px] font-medium text-[#64748B] hover:text-[#0C2856] transition-colors"
        >
          Altura {windHeight}
          <ChevronDown
            size={14}
            className={`transition-transform ${
              dropdownOpen ? "rotate-180" : ""
            }`}
          />
        </button>
        {dropdownOpen && (
          <div className="absolute right-0 top-full mt-1 w-[110px] bg-white border border-gray-200 rounded-lg shadow-lg z-50">
            {WIND_HEIGHTS.map((h) => (
              <button
                key={h}
                onClick={() => {
                  setWindHeight(h);
                  setDropdownOpen(false);
                }}
                className={`block w-full px-4 py-2 text-left text-[12px] transition-colors
                ${
                  windHeight === h
                    ? "bg-gray-50 text-[#0C2856] font-bold"
                    : "text-gray-600 hover:bg-gray-50 hover:text-[#0C2856]"
                }`}
              >
                {h}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HeightDropdown;
